import React from "react";
import "./Footer.scss";
import { Link } from "react-router-dom";
import { cap, clia, hipaa, whiteLogo } from "../../assets/images/images";
import PgtCounseling from "../../common/pgtCounseling/PgtCounseling";
import { footerVideo } from "../../assets/videos/videos";

const Footer = () => {
  return (
    <>
      <footer className="section footer">
        <div className="video-wrapper">
          <video autoPlay muted loop playsInline>
            <source src={footerVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          {/* <div className="hue-overlay"></div> */}
        </div>
        <div className="radial-overlay"></div>
        <PgtCounseling />
        <div className="container">
          <div className="footer-content">
            <div className="left">
              <img src={whiteLogo} alt="logo" />
              <p>Pioneering the future of genetic innovation</p>
            </div>
            <div className="right">
              <div className="links">
                <h3>Product</h3>
                <Link to="/">Home</Link>
                <Link to="/about-us">About us</Link>
                <Link to="/contact-us">Contact us</Link>
                <Link to="/blogs">Blog</Link>
              </div>
              <div className="links">
                <h3>Technology</h3>
                <Link to="/our-technology">PGT</Link>
                <Link to="/genetic-counseling">Counseling</Link>
                <Link to="/faq">FAQs</Link>
              </div>
              <div className="links">
                <h3>Legal</h3>
                <Link to="terms-conditions">Terms</Link>
                <Link to="/privacy-policy">Privacy</Link>
                <Link to="/ethics">Our Ethics</Link>
              </div>
            </div>
          </div>
          <div className="cert">
            <h5>CERTIFIED BY AND COMPLIANT WITH</h5>
          </div>
          <div className="footer-logos">
            <div className="f-logos">
              <img src={clia} alt="clia" />
            </div>
            <div className="f-logos">
              <img src={hipaa} alt="hipaa" />
            </div>
            <div className="f-logos">
              <img src={cap} alt="cap" />
            </div>
          </div>
          <div className="footer-bottom">
            <div className="copyright">
              <p>
                © {new Date().getFullYear()} Gattaca Genomics. All rights
                reserved.
              </p>
            </div>
            <ul className="footer-social-icons">
              <li>
                <a
                  target="blank"
                  href="https://twitter.com/GattacaGenomics"
                  rel="noopener noreferrer"
                >
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="twitter-icon"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M15.9455 23.7544L10.396 15.8445L3.44886 23.7544H0.509766L9.09209 13.9855L0.509766 1.75439H8.05571L13.286 9.20941L19.8393 1.75439H22.7784L14.5943 11.0709L23.4914 23.7544H15.9455ZM19.2185 21.5244H17.2398L4.71811 3.98439H6.6971L11.7121 11.0076L12.5793 12.2263L19.2185 21.5244Z"
                      fill="#98A2B3"
                    />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  target="blank"
                  href="https://www.linkedin.com/company/gattacagenomics/"
                  rel="noopener noreferrer"
                >
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="linkedin-icon"
                  >
                    <g clipPath="url(#clip0_2311_18221)">
                      <path
                        d="M22.2234 0.754395H1.77187C0.792187 0.754395 0 1.52783 0 2.48408V23.02C0 23.9763 0.792187 24.7544 1.77187 24.7544H22.2234C23.2031 24.7544 24 23.9763 24 23.0247V2.48408C24 1.52783 23.2031 0.754395 22.2234 0.754395ZM7.12031 21.206H3.55781V9.74971H7.12031V21.206ZM5.33906 8.18877C4.19531 8.18877 3.27188 7.26533 3.27188 6.12627C3.27188 4.98721 4.19531 4.06377 5.33906 4.06377C6.47813 4.06377 7.40156 4.98721 7.40156 6.12627C7.40156 7.26064 6.47813 8.18877 5.33906 8.18877ZM20.4516 21.206H16.8937V15.6372C16.8937 14.3106 16.8703 12.5997 15.0422 12.5997C13.1906 12.5997 12.9094 14.0481 12.9094 15.5435V21.206H9.35625V9.74971H12.7687V11.3153H12.8156C13.2891 10.4153 14.4516 9.46377 16.1813 9.46377C19.7859 9.46377 20.4516 11.8356 20.4516 14.92V21.206V21.206Z"
                        fill="#98A2B3"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_2311_18221">
                        <rect
                          width="24"
                          height="24"
                          fill="white"
                          transform="translate(0 0.754395)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </li>
              <li>
                <a
                  target="blank"
                  href="https://www.facebook.com/GattacaGenomics"
                  rel="noopener noreferrer"
                >
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="facebook-icon"
                  >
                    <g clipPath="url(#clip0_2311_18222)">
                      <path
                        d="M24 12.7544C24 6.12697 18.6274 0.754395 12 0.754395C5.37258 0.754395 0 6.12697 0 12.7544C0 18.7438 4.3882 23.7084 10.125 24.6086V16.2231H7.07812V12.7544H10.125V10.1106C10.125 7.10315 11.9166 5.44189 14.6576 5.44189C15.9701 5.44189 17.3438 5.67627 17.3438 5.67627V8.62939H15.8306C14.34 8.62939 13.875 9.55447 13.875 10.5044V12.7544H17.2031L16.6711 16.2231H13.875V24.6086C19.6118 23.7084 24 18.7438 24 12.7544Z"
                        fill="#98A2B3"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_2311_18222">
                        <rect
                          width="24"
                          height="24"
                          fill="white"
                          transform="translate(0 0.754395)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
